












































import { computed, defineComponent, ref, toRefs, onMounted } from '@vue/composition-api';
import lottie from 'lottie-web';
import i18n, { i18n_t } from '@/locales/i18n';
import { isAdminOrSuperAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import { httpUrl } from '@/renderer/scripts/http';
import { SMH } from '@/renderer/scripts/smh';

export default defineComponent({
  name: 'WelcomeHome',
  props: {
    isPersonal: Boolean,
  },
  setup(props, context) {
    const vm = context.root;
    const store = vm.$store;
    const { isPersonal } = toRefs(props);
    const showAnimation = ref(true);
    const { isInWeMeetApp, orgChannel } = store.getters;
    const meetChannel = isInWeMeetApp && orgChannel;
    const subtitle = meetChannel
      ? i18n_t('花1分钟来快速了解一下主要功能吧')
      : i18n_t('你可通过我们安全收发企业文件，实现高效会议办公协同');
    const introduces = computed(() => {
      // 企业客户
      if (!isPersonal.value && isAdminOrSuperAdmin.value) {
        return [
          {
            title: i18n_t('企业空间'),
            desc: i18n_t('数据资料沉淀，离职数据不丢失'),
            position: 'left-top',
          },
          {
            title: i18n_t('资产管理'),
            desc: i18n_t('企业级安全权限，水印{slot1}等设置', {
              slot1: !vm.$store.getters.isPrivate ? i18n_t('，云查') : '',
            }),
            position: 'left-middle',
          },
          {
            title: i18n_t('空间管理'),
            desc: i18n_t('统一管理账号，空间{slot1}使用', {
              slot1: !vm.$store.getters.isPrivate ? i18n_t('，流量') : '',
            }),
            position: 'left-bottom',
          },
          {
            title: i18n_t('跨端传输'),
            desc: i18n_t('办公资料跨设备无缝传输与同步'),
            position: 'right-top',
          },
          {
            title: i18n_t('安全存储'),
            desc: i18n_t('交付方案，指定的人才能查看'),
            position: 'right-middle',
          },
          {
            title: i18n_t('企业定制'),
            desc: i18n_t('自定义打造企业专属形象'),
            position: 'right-bottom',
          },
        ];
      }
      return [
        {
          title: i18n_t('安全备份'),
          desc: i18n_t('单端文件上传，多端随时查看'),
          position: 'left-top',
        },
        {
          title: i18n_t('误删恢复'),
          desc: i18n_t('被误删的文档，也可以恢复找回'),
          position: 'left-bottom',
        },
        {
          title: i18n_t('协作空间'),
          desc: i18n_t('办公资料跨设备无缝传输与同步'),
          position: 'right-top',
        },
        {
          title: i18n_t('安全外链'),
          desc: i18n_t('交付方案，指定的人才能查看'),
          position: 'right-bottom',
        },
      ];
    });
    // 组合显示欢迎信息内容
    const welcomeMessage = computed(() => {
      const { editionFlag, userBaseInfo } = vm.$store.getters;

      if (editionFlag === SMH.EditionFlag.personal) {
        return i18n_t('欢迎你，{slot1}', { slot1: userBaseInfo.nickname });
      }

      let msg = i18n_t('欢迎使用腾讯云企业网盘');
      if (userBaseInfo.role !== 'superAdmin') {
        const name = vm.$store.getters.orgName;
        switch (editionFlag) {
          case 'team':
            msg = i18n_t('欢迎你加入{slot1}团队版', { slot1: name });
            break;
          default:
            msg = i18n_t('欢迎你加入{slot1}企业版', { slot1: name });
            break;
        }
        return msg;
      }

      if (meetChannel.value) {
        return i18n_t('欢迎使用腾讯云企业网盘');
      }

      return msg;
    });
    const drawAnimationWrapper = () => {
      const animationWrapper: Element = document.querySelector('.welcome__show-diagram') as Element;
      const str = meetChannel ? 'wemeet-' : '';
      const path = `${httpUrl.staticCDNUrl}/tools/images/guideAnimation/welcome/${str}data.json`;
      const animation = lottie.loadAnimation({
        // 包含动画的dom元素
        container: animationWrapper,
        // 渲染出来的是什么格式
        renderer: 'svg',
        // 循环播放
        loop: true,
        // 自动播放
        autoplay: true,
        // 动画json的路径
        path,
      });

      animation.addEventListener('data_failed', () => {
        showAnimation.value = false;
        animation.removeEventListener('data_failed');
      });
    };
    onMounted(() => {
      // 绘制动态图
      drawAnimationWrapper();
    });
    return {
      subtitle,
      introduces,
      welcomeMessage,
      showAnimation,
      meetChannel,
    };
  },
});
